import { BodyCell } from '@tableau/widgets-datagrid';
import React from 'react';

import { Location } from '~commonInfra/utils/Location';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { openReactAlertDialog } from '~src/commonInfra/dialogs/ReactAlertDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { ExplorerStyles } from '~src/spacesPlatform/components/Explorer/ExplorerStyles';

import { IScimConfiguration, ScimConfigurationsService } from '../../services/ScimConfigurationsService';
import { ActionsMenuItem, AuthenticationActionsMenu } from '../multipleIDPComponents/AuthenticationActionsMenu';
import { ScimConfigurationsColumnKeys } from './ScimConfigurationsGrid';

export interface ScimConfigurationsActionCellOptions {
    refreshGrid: () => void;
    deleteScimIdpConfigurationId: (idToRemove: string) => void;
}

function deleteConfigWithConfirmation(config: IScimConfiguration): Promise<any> {
    if(config.isOwner){
        const dialogInstance = openReactActionDialog({
            title: Messages.scimConfigurationDeleteTitle(),
            bodyComponent: () => deleteScimConfigurationProviderBody(config),
            initialBodyProps: {},
            initialDialogState: {},
            actionName: Messages.scimConfigurationDelete(),
            action: () => {
                return ScimConfigurationsService.deleteScimConfiguration(config).then(() => {
                    ToasterService.instance.pop({ type: ToastType.Success, text: Messages.scimConfigurationDeleteSuccess({ SCIM_CONFIG_NAME: config.name }) });
                }).catch(() => {
                    ToasterService.instance.pop({ type: ToastType.Error, text: Messages.scimConfigurationDeleteError() });
                });
            },
            isActionDelete: true,
            dialogWidth: TabDialogWidth.width375px,
            dismissDialogOnActionFailed: true
        });
        return Promise.resolve(dialogInstance.result);
    }
    else {
        ToasterService.instance.pop({ type: ToastType.Error, text: Messages.onlyConfigOwnerCanDeleteScimConfiguration() });
        return;
    }
}

 function cannotEditScimConfigDialog(): Promise<any> {
        const dialogInstance = openReactAlertDialog({
            title: Messages.editConfigurationDialogTitle(),
            message: Messages.onlyConfigOwnerCanUpdateScimConfigurationMessage(),
            dialogWidth: TabDialogWidth.width375px,
        });
        return Promise.resolve(dialogInstance?.result);
    }

function navigateToEditConfigIfOwner(config: IScimConfiguration): void{
    if (config.isOwner) {
        const urls = siteUrlsSelector(getAppStore().getState());
        const editConfigUrl = urls.scimEditConfigurationUrl(config.id);
        Location.instance.setUrl(editConfigUrl);
    }
    else {
        cannotEditScimConfigDialog();
    }
}


function deleteScimConfigurationProviderBody(config: IScimConfiguration) {
    return (
        <>
            <p>{Messages.scimConfigurationDeleteDesc1({ SCIM_CONFIG_NAME: config.name })}</p>
            <p>{Messages.scimConfigurationDeleteDesc2()}</p>
        </>
    );
}


export function ScimConfigurationsActionsMenuCell(
    options: ScimConfigurationsActionCellOptions,
    cellOverrides: React.CSSProperties = {}
): React.Factory<BodyCell.Props> {
    return React.createFactory(class extends React.Component<BodyCell.Props, {}> {

        render() {
            const config = this.props.row.data[ScimConfigurationsColumnKeys.ScimConfiguration] as IScimConfiguration;
            const actionsMenuDisabled = false;
            const actions: ActionsMenuItem[] = actionsMenuDisabled ? [] : [
                {
                    // Edit...
                    label: Messages.scimConfigurationEditAction(),
                    execute: () => {
                        navigateToEditConfigIfOwner(config);
                        return Promise.resolve();
                    }
                },
                {
                    // Delete...
                    label: Messages.scimConfigurationDeleteAction(),
                    execute: () => {
                        return deleteConfigWithConfirmation(config).then(() => {
                            options.refreshGrid();
                            options.deleteScimIdpConfigurationId(config.idpConfigurationId);
                        });
                    },
                }
            ];

            return (
                <div className={ExplorerStyles.ActionsOnlyCellContainer}>
                    <div>
                        <AuthenticationActionsMenu
                            actions={actions}
                            disabled={actionsMenuDisabled}
                            style={{}}
                            useIcon={true} />
                    </div>
                </div>
            );
        }
    });
}

